<template>
  <div>
    <table>
      <thead>
      <tr>
        <th scope="col">filial</th>
        <th scope="col">sku</th>
        <th scope="col">pertence_mix</th>
        <th scope="col">movimentacao</th>
        <th scope="col">filial_origem</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <th scope="row">1</th>
        <td>SKU001</td>
        <td>SIM</td>
        <td>PROPRIA</td>
        <td></td>
      </tr>
      <tr>
        <th scope="row">2</th>
        <td>SKU002</td>
        <td>SIM</td>
        <td>MISTA</td>
        <td></td>
      </tr>
      <tr>
        <th scope="row">3</th>
        <td>SKU003</td>
        <td>NAO</td>
        <td>PROPIA</td>
        <td></td>
      </tr>
      <tr>
        <th scope="row">3</th>
        <td>SKU004</td>
        <td>NAO</td>
        <td>RETIRA</td>
        <td>1</td>
      </tr>
      <tr>
        <th scope="row">1</th>
        <td>SKU005</td>
        <td>SIM</td>
        <td>RETIRA</td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TabelaExemploUpload'
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 2px solid rgb(140 140 140);
  font-family: sans-serif;
  font-size: 0.8rem;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

caption {
  caption-side: bottom;
  padding: 10px;
  font-weight: bold;
}

thead,
tfoot {
  background-color: rgb(228 240 245);
}

th,
td {
  border: 1px solid rgb(160 160 160);
  padding: 8px 10px;
}

td:last-of-type {
  text-align: center;
}

tbody > tr:nth-of-type(even) {
  background-color: rgb(237 238 242);
}

tfoot th {
  text-align: right;
}

tfoot td {
  font-weight: bold;
}

</style>
